import type { PresenceStatus } from "#app/lib/data";

/**
 * How each live status reads, everywhere it is named: the profile chip, the
 * members filter, a group-by bucket. Unknown (first poll in flight) reads as
 * Offline — the pessimistic default matches the avatar dots' server-confirmed
 * contract. Order is the order a list shows them in.
 */
export const PRESENCE_META: Record<
  PresenceStatus,
  { label: string; color: "success" | "warning" | "muted" }
> = {
  ONLINE: { label: "Online", color: "success" },
  AWAY: { label: "Away", color: "warning" },
  OFFLINE: { label: "Offline", color: "muted" },
};

export const PRESENCE_ORDER: readonly PresenceStatus[] = ["ONLINE", "AWAY", "OFFLINE"];
